__turbopack_context__.v({
  "item": "navigation-item-module-scss-module__J_uoHW__item",
  "link": "navigation-item-module-scss-module__J_uoHW__link",
  "placeholder": "navigation-item-module-scss-module__J_uoHW__placeholder",
  "text": "navigation-item-module-scss-module__J_uoHW__text",
});
